import {
  CaretDownOutlined,
  CloseCircleOutlined,
  EyeOutlined,
  MoreOutlined,
} from "@ant-design/icons";
import { Avatar, Button, Card, Col, Dropdown, Image, Row } from "antd";
import {
  ImageAddIcon,
  ImageRemoveIcon,
  PlusIcon,
  TickIcon,
} from "../../../../../atoms/CustomIcons";
import EmptyCard from "../../../../../atoms/EmptyCard";
import FolderIcon from "../../../../../atoms/CustomIcons/FolderIcon";
import ImageIcon from "../../../../../atoms/CustomIcons/ImageIcon";
import FileIcon from "../../../../../atoms/CustomIcons/FileIcon";
import { useRef } from "react";
import IconFilledFlag from "../../../../../atoms/CustomIcons/IconFilledFlag";
import IconFilledAttachment from "../../../../../atoms/CustomIcons/IconFilledAttachment";
import IconFilledImage from "../../../../../atoms/CustomIcons/IconFilledImage";

export default function WorkDetails() {
  const dropdownRef = useRef<HTMLButtonElement>(null);

  const subServicesItems = [
    {
      key: "1",
      label: (
        <Button
          type="text"
          className="no-hover"
          onClick={(e) => {
            e.stopPropagation();
          }}
          icon={<ImageRemoveIcon />}
        >
          Doesn’t require picture after
        </Button>
      ),
    },
    {
      key: "2",
      label: (
        <Button
          type="text"
          className="no-hover"
          onClick={(e) => {
            e.stopPropagation();
          }}
          icon={<ImageAddIcon />}
        >
          Requires picture after
        </Button>
      ),
    },
  ];

  const statusItems = [
    {
      key: "scheduled",
      label: (
        <Button
          type="text"
          className="no-hover"
          onClick={(e) => {
            e.stopPropagation();
          }}
        >
          <Avatar
            shape="square"
            size={14}
            style={{ backgroundColor: "#6454F4", borderRadius: "2px" }}
          />
          Scheduled
          <TickIcon style={{ color: "#6454F4" }} className="status_checked" />
        </Button>
      ),
    },
    {
      key: "open",
      label: (
        <Button
          type="text"
          className="no-hover"
          onClick={(e) => {
            e.stopPropagation();
          }}
        >
          <Avatar
            shape="square"
            size={14}
            style={{ backgroundColor: "#EFF2F3", borderRadius: "2px" }}
          />
          Open
          <TickIcon style={{ color: "#EFF2F3" }} className="status_checked" />
        </Button>
      ),
    },
    {
      key: "completed",
      label: (
        <Button
          type="text"
          className="no-hover"
          onClick={(e) => {
            e.stopPropagation();
          }}
        >
          <Avatar
            shape="square"
            size={14}
            style={{ backgroundColor: "#00A07D", borderRadius: "2px" }}
          />
          Completed
          <TickIcon style={{ color: "#00A07D" }} className="status_checked" />
        </Button>
      ),
    },
    {
      key: "canceled",
      label: (
        <Button
          type="text"
          className="no-hover"
          onClick={(e) => {
            e.stopPropagation();
          }}
        >
          <Avatar
            shape="square"
            size={14}
            style={{ backgroundColor: "#6C7478", borderRadius: "2px" }}
          />
          Canceled
          <TickIcon style={{ color: "#6C7478" }} className="status_checked" />
        </Button>
      ),
    },
    {
      key: "missed",
      label: (
        <Button
          type="text"
          className="no-hover"
          onClick={(e) => {
            e.stopPropagation();
          }}
        >
          <Avatar
            shape="square"
            size={14}
            style={{ backgroundColor: "#E04949", borderRadius: "2px" }}
          />
          Missed
          <TickIcon style={{ color: "#E04949" }} className="status_checked" />
        </Button>
      ),
    },
    {
      key: "approval_pending",
      label: (
        <Button
          type="text"
          className="no-hover"
          onClick={(e) => {
            e.stopPropagation();
          }}
        >
          <Avatar
            shape="square"
            size={14}
            style={{ backgroundColor: "#F58E45", borderRadius: "2px" }}
          />
          Approval pending
          <TickIcon style={{ color: "#F58E45" }} className="status_checked" />
        </Button>
      ),
    },
  ];

  const albumDropdownItems = [
    {
      key: "1",
      label: (
        <Button
          type="text"
          className="no-hover"
          onClick={(e) => {
            e.stopPropagation();
          }}
        >
          <CloseCircleOutlined style={{ marginTop: "2px" }} /> Remove
        </Button>
      ),
    },
    {
      key: "2",
      label: (
        <Button
          type="text"
          className="no-hover"
          onClick={(e) => {
            e.stopPropagation();
          }}
        >
          <EyeOutlined style={{ marginTop: "2px" }} /> Show to crew
        </Button>
      ),
    },
  ];

  return (
    <div className="workDetails">
      <Row gutter={[16, 16]} wrap={false}>
        <Col span={9}>
          <h3 style={{ marginBottom: "8px" }}> Subservices </h3>
          <Card className="subServiceCard">
            <div className="subServiceCardContent">
              <div
                style={{ display: "flex", alignItems: "center", gap: "8px" }}
              >
                <img
                  src="/images/work-orders/subService.png"
                  alt=""
                  style={{ width: "32px", height: "32px", borderRadius: "6px" }}
                />
                <h4>21” Mowing</h4>
              </div>
              <Dropdown
                menu={{ items: subServicesItems }}
                trigger={["click"]}
                className="actionButton"
                placement="bottomRight"
              >
                <Button
                  onClick={(e) => {
                    e.stopPropagation();
                  }}
                  onKeyDown={(e) => e.stopPropagation()}
                  style={{
                    padding: "0px",
                    height: "28px",
                    width: "28px",
                    border: "1px solid transparent",
                    backgroundColor: "transparent",
                  }}
                  className="status_dropdown"
                  icon={<MoreOutlined />}
                />
              </Dropdown>
            </div>
            <div className="subServiceCardContentDetail">
              <h4 className="sizeUnit">
                20,000 <span>sf</span>
              </h4>
              <h4 className="visitCount"> 51 visits </h4>
            </div>
          </Card>
          <Card className="subServiceCard">
            <div className="subServiceCardContent">
              <div
                style={{ display: "flex", alignItems: "center", gap: "8px" }}
              >
                <img
                  src="/images/work-orders/subService.png"
                  alt=""
                  style={{ width: "32px", height: "32px", borderRadius: "6px" }}
                />
                <h4>48” Mowing</h4>
              </div>

              <Dropdown
                menu={{ items: subServicesItems }}
                trigger={["click"]}
                className="actionButton"
                placement="bottomRight"
              >
                <Button
                  onClick={(e) => {
                    e.stopPropagation();
                  }}
                  onKeyDown={(e) => e.stopPropagation()}
                  style={{
                    padding: "0px",
                    height: "28px",
                    width: "28px",
                    border: "1px solid transparent",
                    backgroundColor: "transparent",
                  }}
                  className="status_dropdown"
                  icon={<MoreOutlined />}
                />
              </Dropdown>
            </div>
            <div className="subServiceCardContentDetail">
              <h4 className="sizeUnit">
                20,000 <span>sf</span>
              </h4>
              <h4 className="visitCount"> 51 visits </h4>
            </div>
          </Card>
          <Card className="subServiceCard">
            <div className="subServiceCardContent">
              <div
                style={{ display: "flex", alignItems: "center", gap: "8px" }}
              >
                <img
                  src="/images/work-orders/subService.png"
                  alt=""
                  style={{ width: "32px", height: "32px", borderRadius: "6px" }}
                />
                <h4>Blowing</h4>
              </div>
              <Dropdown
                menu={{ items: subServicesItems }}
                trigger={["click"]}
                className="actionButton"
                placement="bottomRight"
              >
                <Button
                  onClick={(e) => {
                    e.stopPropagation();
                  }}
                  onKeyDown={(e) => e.stopPropagation()}
                  style={{
                    padding: "0px",
                    height: "28px",
                    width: "28px",
                    border: "1px solid transparent",
                    backgroundColor: "transparent",
                  }}
                  className="status_dropdown"
                  icon={<MoreOutlined />}
                />
              </Dropdown>
            </div>
            <div className="subServiceCardContentDetail">
              <h4 className="sizeUnit">
                5,000 <span>sf</span>
              </h4>
              <h4 className="visitCount"> 51 visits </h4>
            </div>
          </Card>
          <Card className="subServiceCard">
            <div className="subServiceCardContent">
              <div
                style={{ display: "flex", alignItems: "center", gap: "8px" }}
              >
                <img
                  src="/images/work-orders/subService.png"
                  alt=""
                  style={{ width: "32px", height: "32px", borderRadius: "6px" }}
                />
                <h4>Hard Edging</h4>
              </div>
              <Dropdown
                menu={{ items: subServicesItems }}
                trigger={["click"]}
                className="actionButton"
                placement="bottomRight"
              >
                <Button
                  onClick={(e) => {
                    e.stopPropagation();
                  }}
                  onKeyDown={(e) => e.stopPropagation()}
                  style={{
                    padding: "0px",
                    height: "28px",
                    width: "28px",
                    border: "1px solid transparent",
                    backgroundColor: "transparent",
                  }}
                  className="status_dropdown"
                  icon={<MoreOutlined />}
                />
              </Dropdown>
            </div>
            <div className="subServiceCardContentDetail">
              <h4 className="sizeUnit">
                2,000 <span>sf</span>
              </h4>
              <h4 className="visitCount"> 26 visits </h4>
            </div>
          </Card>
          <Card className="subServiceCard">
            <div className="subServiceCardContent">
              <div
                style={{ display: "flex", alignItems: "center", gap: "8px" }}
              >
                <img
                  src="/images/work-orders/subService.png"
                  alt=""
                  style={{ width: "32px", height: "32px", borderRadius: "6px" }}
                />
                <h4>Soft Edging</h4>
              </div>
              <Dropdown
                menu={{ items: subServicesItems }}
                trigger={["click"]}
                className="actionButton"
                placement="bottomRight"
              >
                <Button
                  onClick={(e) => {
                    e.stopPropagation();
                  }}
                  onKeyDown={(e) => e.stopPropagation()}
                  style={{
                    padding: "0px",
                    height: "28px",
                    width: "28px",
                    border: "1px solid transparent",
                    backgroundColor: "transparent",
                  }}
                  className="status_dropdown"
                  icon={<MoreOutlined />}
                />
              </Dropdown>
            </div>
            <div className="subServiceCardContentDetail">
              <h4 className="sizeUnit">
                700 <span>If</span>
              </h4>
              <h4 className="visitCount"> 26 visits </h4>
            </div>
          </Card>
        </Col>
        <Col span={9}>
          <h3
            style={{
              marginBottom: "8px",
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
            }}
          >
            Tasks
            <Button
              onClick={(e) => {
                e.stopPropagation();
              }}
              onKeyDown={(e) => e.stopPropagation()}
              style={{
                padding: "0px",
                height: "28px",
                width: "28px",
                border: "1px solid #DEE5E6",
                backgroundColor: "transparent",
              }}
              className="status_dropdown"
              icon={<PlusIcon />}
            />
          </h3>
          <Card className="subServiceCard">
            <div
              className="subServiceCardContent"
              style={{ marginBottom: "6px" }}
            >
              <div
                style={{ display: "flex", alignItems: "center", gap: "8px" }}
              >
                <h4> Check irrigation coverage </h4>
              </div>
              <Dropdown
                menu={{ items: subServicesItems }}
                trigger={["click"]}
                className="actionButton"
                placement="bottomRight"
              >
                <Button
                  onClick={(e) => {
                    e.stopPropagation();
                  }}
                  onKeyDown={(e) => e.stopPropagation()}
                  style={{
                    padding: "0px",
                    height: "28px",
                    width: "28px",
                    border: "1px solid transparent",
                    backgroundColor: "transparent",
                  }}
                  className="status_dropdown"
                  icon={<MoreOutlined />}
                />
              </Dropdown>
            </div>
            <p>
              Make sure all sprinkler heads in Zones 1 & 2 are functioning
              correctly and covering the lawn evenly. Clear any debris that may
              obstruct the spray. Here’s a photo to give you a clear idea of how
              this task should look when done right:
            </p>
            <div className="woCardFooter">
              <div className="woCardFooterIcons">
                <IconFilledFlag />
                <IconFilledAttachment />
                <IconFilledImage />
              </div>
              <div>
                <Dropdown
                  menu={{
                    items: statusItems,
                    selectable: true,
                    selectedKeys: ["completed"],
                  }}
                  trigger={["click"]}
                  overlayClassName="status_dropdown_overlay"
                >
                  <Button
                    onClick={(e) => {
                      e.stopPropagation();
                    }}
                    onKeyDown={(e) => e.stopPropagation()}
                    className={`status_dropdown completed_status`}
                    ref={dropdownRef}
                  >
                    Scheduled
                    <div className="icon_arrow">
                      <CaretDownOutlined />
                    </div>
                  </Button>
                </Dropdown>
              </div>
            </div>
          </Card>
          <Card className="subServiceCard">
            <div
              className="subServiceCardContent"
              style={{ marginBottom: "6px" }}
            >
              <div
                style={{ display: "flex", alignItems: "center", gap: "8px" }}
              >
                <h4> Clean sidewalk edges </h4>
              </div>
              <Dropdown
                menu={{ items: subServicesItems }}
                trigger={["click"]}
                className="actionButton"
                placement="bottomRight"
              >
                <Button
                  onClick={(e) => {
                    e.stopPropagation();
                  }}
                  onKeyDown={(e) => e.stopPropagation()}
                  style={{
                    padding: "0px",
                    height: "28px",
                    width: "28px",
                    border: "1px solid transparent",
                    backgroundColor: "transparent",
                  }}
                  className="status_dropdown"
                  icon={<MoreOutlined />}
                />
              </Dropdown>
            </div>

            <div className="woCardFooter">
              <div className="woCardFooterIcons">
                <IconFilledFlag />
                <IconFilledAttachment />
                <IconFilledImage />
              </div>
              <div>
                <Dropdown
                  menu={{
                    items: statusItems,
                    selectable: true,
                    selectedKeys: ["scheduled"],
                  }}
                  trigger={["click"]}
                  overlayClassName="status_dropdown_overlay"
                >
                  <Button
                    onClick={(e) => {
                      e.stopPropagation();
                    }}
                    onKeyDown={(e) => e.stopPropagation()}
                    className={`status_dropdown completed_status`}
                    ref={dropdownRef}
                  >
                    Scheduled
                    <div className="icon_arrow">
                      <CaretDownOutlined />
                    </div>
                  </Button>
                </Dropdown>
              </div>
            </div>
          </Card>
          <Card className="subServiceCard">
            <div
              className="subServiceCardContent"
              style={{ marginBottom: "6px" }}
            >
              <div
                style={{ display: "flex", alignItems: "center", gap: "8px" }}
              >
                <h4> Clear leaves from lawn </h4>
              </div>
              <Dropdown
                menu={{ items: subServicesItems }}
                trigger={["click"]}
                className="actionButton"
                placement="bottomRight"
              >
                <Button
                  onClick={(e) => {
                    e.stopPropagation();
                  }}
                  onKeyDown={(e) => e.stopPropagation()}
                  style={{
                    padding: "0px",
                    height: "28px",
                    width: "28px",
                    border: "1px solid transparent",
                    backgroundColor: "transparent",
                  }}
                  className="status_dropdown"
                  icon={<MoreOutlined />}
                />
              </Dropdown>
            </div>
            <p>
              Scan the entire property and remove any trash or debris left
              behind.
            </p>
            <div className="woCardFooter">
              <div className="woCardFooterIcons">
                <IconFilledFlag />
                <IconFilledAttachment />
                <IconFilledImage />
              </div>
              <div>
                <Dropdown
                  menu={{
                    items: statusItems,
                    selectable: true,
                    selectedKeys: ["missed"],
                  }}
                  trigger={["click"]}
                  overlayClassName="status_dropdown_overlay"
                >
                  <Button
                    onClick={(e) => {
                      e.stopPropagation();
                    }}
                    onKeyDown={(e) => e.stopPropagation()}
                    className={`status_dropdown completed_status`}
                    ref={dropdownRef}
                  >
                    Open
                    <div className="icon_arrow">
                      <CaretDownOutlined />
                    </div>
                  </Button>
                </Dropdown>
              </div>
            </div>
          </Card>
          <Card className="subServiceCard">
            <div
              className="subServiceCardContent"
              style={{ marginBottom: "6px" }}
            >
              <div
                style={{ display: "flex", alignItems: "center", gap: "8px" }}
              >
                <h4> Weed flower beds </h4>
              </div>
              <Dropdown
                menu={{ items: subServicesItems }}
                trigger={["click"]}
                className="actionButton"
                placement="bottomRight"
              >
                <Button
                  onClick={(e) => {
                    e.stopPropagation();
                  }}
                  onKeyDown={(e) => e.stopPropagation()}
                  style={{
                    padding: "0px",
                    height: "28px",
                    width: "28px",
                    border: "1px solid transparent",
                    backgroundColor: "transparent",
                  }}
                  className="status_dropdown"
                  icon={<MoreOutlined />}
                />
              </Dropdown>
            </div>
            <p>
              Pull out visible weeds from all garden beds, especially near the
              front entrance.
            </p>
            <div className="woCardFooter">
              <div className="woCardFooterIcons">
                <IconFilledFlag />
                <IconFilledAttachment />
                <IconFilledImage />
              </div>
              <div>
                <Dropdown
                  menu={{
                    items: statusItems,
                    selectable: true,
                    selectedKeys: ["missed"],
                  }}
                  trigger={["click"]}
                  overlayClassName="status_dropdown_overlay"
                >
                  <Button
                    onClick={(e) => {
                      e.stopPropagation();
                    }}
                    onKeyDown={(e) => e.stopPropagation()}
                    className={`status_dropdown completed_status`}
                    ref={dropdownRef}
                  >
                    Open
                    <div className="icon_arrow">
                      <CaretDownOutlined />
                    </div>
                  </Button>
                </Dropdown>
              </div>
            </div>
          </Card>
        </Col>
        <Col
          span={6}
          onClick={() =>
            window.open(
              "https://www.figma.com/proto/tIRfYY9zJMm3JAkzuZz2Tn/LS--Branding---Marketing?page-id=2596%3A60353&node-id=2985-233871&p=f&viewport=3230%2C3079%2C0.31&t=BgbjHvEjnw9ohjvG-1&scaling=scale-down&content-scaling=fixed&starting-point-node-id=2985%3A233871",
              "_blank"
            )
          }
        >
          <h3
            style={{
              marginBottom: "8px",
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              cursor: "pointer",
            }}
          >
            Documents
            <Button
              onClick={(e) => {
                e.stopPropagation();
              }}
              onKeyDown={(e) => e.stopPropagation()}
              style={{
                padding: "0px",
                height: "28px",
                width: "28px",
                border: "1px solid #DEE5E6",
                backgroundColor: "transparent",
              }}
              className="status_dropdown"
              icon={<PlusIcon />}
            />
          </h3>
          <Card className="documentsCard">
            <div className="imagesCollage">
              <Image src="/images/work-orders/prev_1.png" alt="Profile"></Image>
              <Image src="/images/work-orders/prev_2.png" alt="Profile"></Image>
              <Image src="/images/work-orders/prev_3.jpg" alt="Profile"></Image>
              <Image src="/images/work-orders/prev_4.jpg" alt="Profile"></Image>
              <div className="overlayImage">
                <div
                  style={{ display: "flex", alignItems: "center", gap: "7px" }}
                >
                  <FolderIcon /> Photos for task 2
                </div>
                <Dropdown
                  menu={{ items: albumDropdownItems }}
                  trigger={["click"]}
                  className="actionButton"
                  placement="bottomRight"
                >
                  <Button
                    onClick={(e) => {
                      e.stopPropagation();
                    }}
                    onKeyDown={(e) => e.stopPropagation()}
                    style={{
                      padding: "0px",
                      height: "28px",
                      width: "28px",
                      border: "1px solid transparent",
                      backgroundColor: "transparent",
                    }}
                    className="status_dropdown albumDropdownItems"
                    icon={<MoreOutlined style={{ color: "#fff" }} />}
                  />
                </Dropdown>
              </div>
            </div>

            <div className="singleImage">
              <Image
                src="/images/work-orders/weed_flower.png"
                alt="Profile"
              ></Image>
              <div className="overlayImage">
                <div
                  style={{ display: "flex", alignItems: "center", gap: "7px" }}
                >
                  <ImageIcon /> Weed flower beds
                </div>
                <Dropdown
                  menu={{ items: albumDropdownItems }}
                  trigger={["click"]}
                  className="actionButton"
                  placement="bottomRight"
                >
                  <Button
                    onClick={(e) => {
                      e.stopPropagation();
                    }}
                    onKeyDown={(e) => e.stopPropagation()}
                    style={{
                      padding: "0px",
                      height: "28px",
                      width: "28px",
                      border: "1px solid transparent",
                      backgroundColor: "transparent",
                    }}
                    className="status_dropdown"
                    icon={<MoreOutlined style={{ color: "#fff" }} />}
                  />
                </Dropdown>
              </div>
            </div>

            <div className="singleImage">
              <Image
                src="/images/work-orders/irrigation.png"
                alt="Profile"
              ></Image>
              <div className="overlayImage">
                <div
                  style={{ display: "flex", alignItems: "center", gap: "7px" }}
                >
                  <ImageIcon /> Irrigation system
                </div>
                <Dropdown
                  menu={{ items: albumDropdownItems }}
                  trigger={["click"]}
                  className="actionButton"
                  placement="bottomRight"
                >
                  <Button
                    onClick={(e) => {
                      e.stopPropagation();
                    }}
                    onKeyDown={(e) => e.stopPropagation()}
                    style={{
                      padding: "0px",
                      height: "28px",
                      width: "28px",
                      border: "1px solid transparent",
                      backgroundColor: "transparent",
                    }}
                    className="status_dropdown"
                    icon={<MoreOutlined style={{ color: "#fff" }} />}
                  />
                </Dropdown>
              </div>
            </div>

            <div className="singleImage">
              <Image
                src="/images/work-orders/blowing.png"
                alt="Profile"
              ></Image>
              <div className="overlayImage">
                <div
                  style={{ display: "flex", alignItems: "center", gap: "7px" }}
                >
                  <FileIcon /> Blowing process
                </div>
                <Dropdown
                  menu={{ items: albumDropdownItems }}
                  trigger={["click"]}
                  className="actionButton"
                  placement="bottomRight"
                >
                  <Button
                    onClick={(e) => {
                      e.stopPropagation();
                    }}
                    onKeyDown={(e) => e.stopPropagation()}
                    style={{
                      padding: "0px",
                      height: "28px",
                      width: "28px",
                      border: "1px solid transparent",
                      backgroundColor: "transparent",
                    }}
                    className="status_dropdown"
                    icon={<MoreOutlined style={{ color: "#fff" }} />}
                  />
                </Dropdown>
              </div>
            </div>

            <div
              className="empty_wrap"
              style={{ width: "253px", margin: "0 auto", display: "none" }}
            >
              <EmptyCard
                imageHeight={117}
                title="No documents"
                description="Attach any documents that crew or management might need."
                image={"/images/empty-icons/no-archived.svg"}
              />
            </div>
          </Card>
        </Col>
      </Row>
    </div>
  );
}
